import { designTokens } from '../tokens';

/** 상세의 제목·요약·본문 시작선을 공유합니다. 세로 간격은 내용의 밀도를 유지합니다. */
export const detailContentPadding = {
  px: `${designTokens.layout.detailInlineInset}px`,
  py: {
    xs: `${designTokens.layout.surfacePaddingCompact}px`,
    sm: `${designTokens.layout.surfacePadding}px`,
  },
};
